

import React from 'react'

function LoadingEquipmentAppPrivacyPolicy() {
  return (
    <>
      <div style={{ height: "100vh", overflow: "auto" }} class="text-start p-4">
        <div class="row">
          <div class="col-sm-12">

            <div>
              <h1>Loading Equipment Application</h1>
            </div>
            <div class="post-title">
              <h2 style={{ color: "#ee1651" }}>Privacy Policy </h2>
            </div>
            <div class="post-content">
              <p>
                <strong>  Introduction</strong><br />

                Welcome to Solid Waste Management. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and protect your information when you use our mobile application. when you use our mobile application.</p>

              <p>
                <strong> Purpose</strong><br />

                The Loading Equipment Application efficiently manages the operations of loading equipment for secondary and tertiary vehicles. It ensures proper tracking and deployment of loading equipment, minimizing downtime and enhancing productivity. This app is crucial for optimizing logistics and maintaining an uninterrupted workflow in vehicle operations.</p>

              <p>
                <strong> Information We Collect
                  Personal Information:</strong><br />

                We collect personal information, including your name, phone number, and other details necessary to address issues raised by the user (petitioner) and to provide the functionality of the application. We do not collect any personal user data except for tracking the mobile number to display service results and provide personalized services.</p>


              <p>
                <strong>   Non-Personal Data:</strong><br />
                We use images and free image banners to support the application.</p>

              <p>
                <strong>Permissions We Require</strong><br />
                <strong> Camera:</strong><br />
                The app requires access to the camera to capture images related to grievances and vehicle tracking. These images are used temporarily within the app to document issues or verify vehicle arrivals. Images are stored locally on the device and are deleted after use. They are not uploaded or stored permanently, and are only shared within the app with the user's explicit consent..</p>

              <p>
                <strong>
                  External Storage: </strong><br />

                The app accesses external storage specifically to retrieve media files (images) from the gallery. This is necessary for users to upload supporting images when registering grievances or sharing operational data. We do not request access to all files. Instead, we use the MediaStore API to access only media files, in compliance with Google Play's permissions policy. This ensures that the app functions correctly while respecting user privacy and device security.
              </p>

              <p>
                <strong>
                  Location: </strong><br />

                We access location services to track the movement and arrival of vehicles at transfer stations and P&D units. This helps ensure accurate logging of vehicle positions, improves logistical efficiency, and enhances operational transparency. Location data is used only for tracking purposes and is not shared or stored beyond its intended use.
              </p>
              <p>
                <strong>
                  How We Use Your Information</strong><br />

                We use the information we collect to:
              </p><ul>
                <li>Provide and improve our services.</li>
                <li>Personalize your experience.</li>
                <li>Communicate with you.</li>
                <li>Ensure the security of our app and users.</li>
                <li>Comply with legal obligations.</li>
              </ul>
              <p></p>


              <p>
                <strong> Sharing Your Information</strong><br />

                We do not share your personal information with third parties except:
              </p><ul>
                <li>With your consent.</li>
                <li>For processing and service provision by trusted partners.</li>
                <li>To comply with legal requirements.</li>
                <li>To protect our rights and the rights of our users.</li>
              </ul>
              <p></p>

              <p>
                <strong>
                  Data Security </strong><br />

                We implement reasonable security measures to protect your information from unauthorized access, alteration, disclosure, or destruction. All payment transactions are handled securely through trusted payment gateways.</p>

              <p>
                <strong>
                  Your Choices </strong><br />

                You can manage your privacy settings and control what information you share with us through your device settings.</p>

              <p>
                <strong>
                  Children's Privacy</strong><br />
                Our app is not intended for children under the age of 13. We do not knowingly collect personal information from children.</p>

              <p>
                <strong>     Changes to This Privacy Policy</strong><br />

                We may update this Privacy Policy from time to time. Any changes will be posted on this page. We encourage you to review this page periodically to stay informed about how we protect your information.

              </p>

              <p>
                <strong>      Contact Us </strong><br />

                If you have any questions or concerns about this Privacy Policy, please contact us at:
                Email: himsw.ccc@gmail.com

              </p>



            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default LoadingEquipmentAppPrivacyPolicy
